import { render } from "./reviewHistoryDetail.vue?vue&type=template&id=2282526d&scoped=true"
import script from "./reviewHistoryDetail.vue?vue&type=script&lang=js"
export * from "./reviewHistoryDetail.vue?vue&type=script&lang=js"

import "./reviewHistoryDetail.vue?vue&type=style&index=0&id=2282526d&lang=sass&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2282526d"]])

export default __exports__